export { GalleryCategories } from "./categories";
export { GalleryImageCounter } from "./counter";
export { GalleryDots } from "./dots";
export { GalleryInfoButton } from "./info";
